import { createCrudActions } from '../utils/crudGenerator';

const formatMeals = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchMeals,
    create: createMeal,
    update: updateMeal,
    delete: deleteMeals
} = createCrudActions('MEAL', "Plato", formatMeals);